import { useEffect } from "react";

import { pushGlobalValuesToDataLayer } from "seneca-common/features/analytics/gtm";

import { Data } from "../../common";

export type GlobalScopeKeys = "appVersion" | "isMobile" | "mobileDeviceType";

export function usePushToDataLayer<T extends Data>(
  key: GlobalScopeKeys,
  value: T
) {
  useEffect(() => {
    pushGlobalValuesToDataLayer({
      [key]: value
    });
  }, [key, value]);
}
